import React from 'react';
import { X } from 'lucide-react';
import { Post } from '../../types';

interface PreviewModalProps {
  post: Post | null;
  isOpen: boolean;
  onClose: () => void;
}

const PreviewModal: React.FC<PreviewModalProps> = ({ post, isOpen, onClose }) => {
  if (!isOpen || !post) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-4 border-b flex justify-between items-center">
          <h2 className="text-xl font-bold">Preview</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-8">
          <h1 className="text-4xl font-bold mb-4">{post.title}</h1>
          <p className="text-lg text-gray-700 whitespace-pre-wrap">
            {post.content}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;
